var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card-group',_vm._b({},'b-card-group',{ ..._vm.$attrs, ..._vm.$props },false))
}
var staticRenderFns = []

export { render, staticRenderFns }